<template>
  <div class="md:grid grid-cols-appPage gap-twentyFive">
    <div>
      <NoEnvelopesEmptyState v-if="!templatesEnvelopes.length" />
      <div v-else>
        <EnvelopeOverviewCard
          v-for="envelope in templatesEnvelopes"
          :key="envelope.fingerprint"
          :loading="!hasLoaded"
          :envelope="envelope"
        />
        <SElPagination
          v-if="templatesEnvelopesHasLoadedTotalPages"
          class="p-document-selection-form__paginate"
          :pager-count="5"
          :page-count="templatesEnvelopesHasLoadedTotalPages"
          :current-page.sync="templatesEnvelopesCurrentPage"
        />
        <PageResultsCounter
          v-if="templatesEnvelopesResultsMeta && templatesEnvelopesTotalCount"
          :from="templatesEnvelopesResultsMeta.from"
          :to="templatesEnvelopesResultsMeta.to"
          :total="templatesEnvelopesTotalCount"
          :type="$t('functional.envelopes')"
          class="mt-{10px}"
        />
      </div>
    </div>
    <div>
      <div class="g-sidebar__container">
        <h3 class="g-sidebar__container__header">
          <InfoCircleIcon
            height="22"
            width="22"
          />
          <span>{{ $t('functional.whatIsThis') }}</span>
        </h3>
        <p>{{ $t('template.viewAssociatedEnvelopes.whatIsThisMessage', {template: template.title}) }}</p>
      </div>
      <HelpAndSupportWidget />
    </div>
  </div>
</template>

<script>
import SElPagination from '@/views/components/SElPagination.vue';
import PageResultsCounter from '@/views/components/PageResultsCounter.vue';
import NoEnvelopesEmptyState from '@/components/ui/envelopes/NoEnvelopesEmptyState.vue';
import EnvelopeOverviewCard from '@/components/ui/envelopes/EnvelopeOverviewCard.vue';
import { mapActions, mapGetters } from 'vuex';
import HelpAndSupportWidget from '@/views/components/HelpAndSupportWidget.vue';
import { InfoCircleIcon } from '@/components/icons/fontIcons';

export default {
  name: 'TemplateAssociatedEnvelopes',
  components: {
    HelpAndSupportWidget,
    NoEnvelopesEmptyState,
    EnvelopeOverviewCard,
    SElPagination,
    PageResultsCounter,
    InfoCircleIcon,
  },
  computed: {
    ...mapGetters({
      templatesEnvelopes: 'templatesEnvelopes/pagedResults',
      templatesEnvelopesHasLoaded: 'templatesEnvelopes/hasLoaded',
      templatesEnvelopesHasLoadedTotalPages: 'templatesEnvelopes/totalPages',
      templatesEnvelopesResultsMeta: 'templatesEnvelopes/meta',
      templatesEnvelopesTotalCount: 'templatesEnvelopes/totalCount',
      template: 'template/selected',
    }),
    hasLoaded() {
      return this.templatesEnvelopesHasLoaded && this.$store.getters['template/selected'].fingerprint;
    },
  },
  data() {
    return {
      fingerprint: null,
      templatesEnvelopesCurrentPage: 1,
    };
  },
  watch: {
    templatesEnvelopesCurrentPage(page) {
      this.loadTemplatesEnvelopes(page);
    },
  },
  methods: {
    ...mapActions({
      getTemplate: 'template/GET',
      getTemplatesEnvelopes: 'templatesEnvelopes/PAGINATE',
    }),
    loadTemplatesEnvelopes(page) {
      this.getTemplatesEnvelopes({
        page,
        pageLimit: 24,
        templateFingerprint: this.fingerprint,
      });
    },
  },
  mounted() {
    this.fingerprint = this.$route.params.templateId;
    this.getTemplate({ id: this.fingerprint });
    this.loadTemplatesEnvelopes(this.templatesEnvelopesCurrentPage);
  },
};
</script>
